import { render, staticRenderFns } from "./FcSliderRange.vue?vue&type=template&id=6c45b045"
import script from "./FcSliderRange.vue?vue&type=script&lang=js"
export * from "./FcSliderRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports